<template>
  <div class="dashboard">
    <DashboardPro />
  </div>
</template>

<script>
// @ is an alias to /src
import DashboardPro from '@/components/Dashboard/DashboardPro.vue'

export default {
  name: 'dashboardPro',
  components: {
    DashboardPro
  }
}
</script>